import React from "react";
import { Card } from "@deere/ux.uxframe-react";

const ServiceDown = () => {
    return <ServiceDownMsg />
}

const ServiceDownMsg = () => {
    return (
        <div>
            <Card>
                <label style={errorStyle}>&nbsp;Something went wrong.  Please try again.</label>
                <label style={errorStyle}>&nbsp;If the problem persists, please click <b>Contact Us</b> at the top of the page.</label>
            </Card>
        </div>
    );
}

const errorStyle = {
   color : "red"
};

export default ServiceDown;